<template>
  <div>
    <h2>权限申请审批</h2>

    <!-- 权限审批表格 -->
    <el-table :data="applications" style="width: 100%" border stripe>
      <el-table-column prop="userName" label="申请用户" width="200"></el-table-column>
      <el-table-column prop="permissionName" label="申请权限" width="200"></el-table-column>
      <el-table-column prop="reason" label="拒绝原因" width="200"></el-table-column>
      <el-table-column prop="applyTime" label="申请时间" width="200">
        <template #default="{ row }">
          {{ formatDate(row.applyTime) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="150">
        <template #default="{ row }">
          <el-tag :type="row.status === 'PENDING' ? 'warning' : row.status === 'APPROVED' ? 'success' : 'danger'">
            {{ statusMapping[row.status] }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200">
        <template #default="{ row }">
          <el-button
              type="success"
              size="small"
              :disabled="row.status !== 'PENDING'"
              @click="approveApplication(row)"
          >
            批准
          </el-button>
          <el-button
              type="danger"
              size="small"
              :disabled="row.status !== 'PENDING'"
              @click="openRejectDialog(row)"
          >
            拒绝
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        :current-page="pagination.page"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, prev, pager, next, jumper"
        @current-change="handlePageChange"
    ></el-pagination>

    <!-- 拒绝理由对话框 -->
    <el-dialog
        v-model="rejectDialogVisible"
        title="拒绝权限申请"
        width="400px"
    >
      <p>请输入拒绝理由：</p>
      <el-input
          v-model="rejectReason"
          type="textarea"
          placeholder="请填写拒绝理由"
          rows="4"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmRejectApplication">确认拒绝</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
import axios from '@/axios'
export default {


  data() {
    return {
      applications: [], // 权限申请列表
      statusMapping: {
        PENDING: "待审批",
        APPROVED: "已批准",
        REJECTED: "已拒绝",
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      rejectDialogVisible: false, // 控制拒绝对话框的显示状态
      rejectReason: "", // 保存拒绝理由
      selectedApplication: null, // 当前选中的申请
    };
  },
  methods: {
    // 获取权限申请数据
    fetchApplications() {
      const { page, size } = this.pagination;

      axios
          .get("/Admin/permissionApplications", { params: { page, size } })
          .then((response) => {
            if (response.data.success) {
              const records = response.data.data;
              const total = response.data.total;
              this.applications = records.map((item) => ({
                ...item,
                applyTime: item.applyTime ? new Date(item.applyTime) : null,
              }));
              this.pagination.total = total;
            } else {
              ElMessage.error(response.data.errorMsg);
            }
          })
          .catch((error) => {
            console.error("获取权限申请数据失败:", error);
            ElMessage.error("获取权限申请数据失败！");
          });
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d
          .getDate()
          .toString()
          .padStart(2, "0")}`;
    },

    // 批准申请
    approveApplication(application) {
      axios
          .post("/Admin/approvePermission", { id: application.id })
          .then((response) => {
            if (response.data.success) {
              ElMessage.success("权限申请已批准！");
              this.fetchApplications();
            } else {
              ElMessage.error(response.data.errorMsg);
            }
          })
          .catch((error) => {
            console.error("批准权限申请失败:", error);
            ElMessage.error("批准权限申请失败！");
          });
    },

    // 打开拒绝对话框
    openRejectDialog(application) {
      this.selectedApplication = application;
      this.rejectReason = "";
      this.rejectDialogVisible = true;
    },

    // 确认拒绝申请
    confirmRejectApplication() {
      if (!this.rejectReason.trim()) {
        ElMessage.error("拒绝理由不能为空！");
        return;
      }
      const application = this.selectedApplication;
      axios
          .post("/Admin/rejectPermission", {
            id: application.id,
            reason: this.rejectReason,
          })
          .then((response) => {
            if (response.data.success) {
              ElMessage.success("权限申请已拒绝！");
              this.fetchApplications();
            } else {
              ElMessage.error(response.data.errorMsg);
            }
          })
          .catch((error) => {
            console.error("拒绝权限申请失败:", error);
            ElMessage.error("拒绝权限申请失败！");
          })
          .finally(() => {
            this.rejectDialogVisible = false;
          });
    },

    // 分页变化
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.fetchApplications();
    },
  },
  created() {
    this.fetchApplications();
  },
};

</script>